/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-cycle */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect } from 'react';
import { Link, useNavigate, NavLink } from 'react-router-dom';
import { MdOutlineCancel } from 'react-icons/md';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';

import { links } from '../data/dummy';
import { useStateContext } from '../contexts/ContextProvider';
import { Methods } from '../pages/Methods';
import '../pages/Zackat.css';

const Sidebar = () => {
  const {
    currentColor,
    activeMenu,
    setActiveMenu,
    screenSize,
    inventoryCount,
    setInventoryCount,
    associateCount,
    reloadCounts,
    setAssociateCount,
    managerCount,
    setManagerCount,
    boss,
    isMobile,
    //    elapsed,
    setBoss,
    eventLimit,
    sstEventLimit,
    logLimit,
    chartLimit,
  } = useStateContext();
  const navigate = useNavigate();
  const currentActiveMenu = localStorage.getItem('activeMenu');
  useEffect(() => {
    localStorage.setItem('activeMenu', activeMenu);
  }, [activeMenu]);
  const handleCloseSideBar = () => {
    if (activeMenu !== undefined && screenSize <= 900) {
      setActiveMenu(false);
    }
  };
  const { REACT_APP_ENV, REACT_APP_API_ENDPOINT } = process.env;
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (usr) {
    usr = JSON.parse(usr);
  }
  if (selectedOrg) {
    selectedOrg = JSON.parse(selectedOrg);
  }
  if (usr && selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
    usr.organizationid = selectedOrg.id;
  }

  const { loading, data } = Methods('user', 'GET', '') || {};

  useEffect(() => {
    const el = Number(localStorage.getItem('eventLimit'));
    const cl = Number(localStorage.getItem('chartLimit'));
    const ll = Number(localStorage.getItem('logLimit'));
    const sl = Number(localStorage.getItem('sstEventLimit'));
    if (!data || !data.user) {
      return;
    }
    if (!data.user.preferences) {
      data.user.preferences = {};
    }
    if (!data.user.preferences.limits) {
      data.user.preferences.limits = {};
    }
    data.user.preferences.limits = { eventLimit: Number(el), chartLimit: Number(cl), logLimit: Number(ll), sstEventLimit: Number(sl) };
    // Remove the New Password to avoid creating a new password
    data.user.newPassword = '';
    // Avoid Password comparison
    data.user.password = '';
    if (data.user.lastLogin && data.user.lastLogin === '') {
      data.user.lastLogin = '1970-01-01T00:00:00.000Z';
    }

    fetch(`${REACT_APP_API_ENDPOINT}/user`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(data.user),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          console.error('sidebar', responseJson.response);
        } else {
          if (data.user.preferences.limits.eventLimit) {
            localStorage.setItem('eventLimit', data.user.preferences.limits.eventLimit.toString());
          }
          if (data.user.preferences.limits.chartLimit) {
            localStorage.setItem('chartLimit', data.user.preferences.limits.chartLimit.toString());
          }
          if (data.user.preferences.limits.logLimit) {
            localStorage.setItem('logLimit', data.user.preferences.limits.logLimit.toString());
          }
          if (data.user.preferences.limits.sstEventLimit) {
            localStorage.setItem('sstEventLimit', data.user.preferences.limits.sstEventLimit.toString());
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [associateCount, logLimit, chartLimit, eventLimit, sstEventLimit]);

  useEffect(() => {
    const fetchCount = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/associates?count=true&${query}`;
      if (!usr.loggedIn) {
        navigate('/login');
        return;
      }
      // console.log('Fetching counts', url);
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json()
        .catch((err) => {
          console.error('Error parsing JSON:', err);
          return null;
        });
      setAssociateCount(mydata.associateCount);
      setInventoryCount(mydata.inventoryCount);
      setManagerCount(mydata.managerCount);
      if (mydata.boss === 'true') {
        setBoss(true);
      } else {
        setBoss(false);
      }
    };
    fetchCount();
  }, [reloadCounts]);

  const activeLink = 'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg  text-white  text-md m-0';
  const normalLink = 'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-md text-gray-700 dark:text-gray-200 dark:hover:text-black hover:bg-light-gray m-0';
  if (loading) {
    return <p>Loading... </p>;
  }
  let orgRead = false;
  let associateRead = false;
  let rolesRead = false;
  let inventoryRead = false;
  let usersRead = false;
  let calendarRead = false;
  let calliopeRead = false;
  let alertsRead = false;
  let dashboardRead = false;
  let billingRead = false;
  let reportsRead = false;
  let onboard = false;
  let stats = false;
  let templates = false;
  if (!data || !data.role) {
    navigate('/login');
    return <p>Please login... </p>;
  }
  if (data && data.role && data.role.roles && data.role.roles.permissions && data.role.roles.permissions.includes('Read')) {
    rolesRead = true;
  }
  if (data && data.role && data.role.organizations && data.role.organizations.permissions && data.role.organizations.permissions.includes('Read')) {
    orgRead = true;
  }
  if (data && data.role && data.role.organizations && data.role.organizations.permissions && data.role.organizations.permissions.includes('Onboarding')) {
    onboard = true;
  }
  if (data && data.role && data.role.organizations && data.role.organizations.permissions && data.role.organizations.permissions.includes('Stats')) {
    stats = true;
  }
  if (data && data.role && data.role.organizations && data.role.organizations.permissions && data.role.organizations.permissions.includes('Templates')) {
    templates = true;
  }
  if (data && data.role && data.role.associates && data.role.associates.permissions && data.role.associates.permissions.includes('Read')) {
    associateRead = true;
  }
  if (data && data.role && data.role.roles && data.role.inventory.permissions && data.role.inventory.permissions.includes('Read')) {
    inventoryRead = true;
  }
  if (data && data.role && data.role.roles && data.role.roles.permissions && data.role.roles.permissions.includes('Read')) {
    rolesRead = true;
  }
  if (data && data.role && data.role.users && data.role.users.permissions && data.role.users.permissions.includes('Read')) {
    usersRead = true;
  }
  if (data && data.role && data.role.calendar && data.role.calendar.permissions && data.role.calendar.permissions.includes('Read')) {
    calendarRead = true;
  }
  if (data && data.role && data.role.calendar.permissions && data.role.calendar.permissions.includes('Calliope')) {
    calliopeRead = true;
  }
  if (data && data.role && data.role.dashboard && data.role.dashboard.permissions && data.role.dashboard.permissions.includes('Read')) {
    dashboardRead = true;
  }
  if (data && data.role && data.role.alerts && data.role.alerts.permissions && data.role.alerts.permissions.includes('Read')) {
    alertsRead = true;
  }
  if (data && data.role && data.role.billing && data.role.billing.permissions && data.role.billing.permissions.includes('Read')) {
    billingRead = true;
  }
  if (data && data.role && data.role.reports && data.role.reports.permissions && data.role.reports.permissions.includes('Read')) {
    reportsRead = true;
  }
  function viewPermission(item) {
    if (data.user.onboard === true && (item.title === 'Administration' || (item.name === 'onboarding' && onboard))) {
      return true;
    } if (data.user.onboard === false) {
      if ((orgRead || usersRead || rolesRead || dashboardRead) && item.title === 'Administration') {
        return true;
      }
      if (alertsRead && item.title === 'SafeGuards' && !isMobile) {
        return true;
      }
      if (associateRead && item.title === 'Operations') {
        return true;
      }
      if (inventoryRead && item.title === 'Inventory' && !isMobile) {
        return true;
      }
      if (associateRead && data.role.associates.permissions.includes('Managers') && item.title === 'Supervisory') {
        return true;
      }
      if ((billingRead || reportsRead) && item.title === 'Dashboards' && !isMobile) {
        return true;
      }
      if (calendarRead && item.title === 'Apps' && !isMobile) {
        return true;
      }
      if (boss && item.title === 'Campaign' && !isMobile) {
        return true;
      }
      if (orgRead && item.name === 'organizations' && !isMobile) {
        return true;
      }
      if (onboard && item.name === 'onboarding' && !isMobile) {
        return true;
      }
      if (stats && item.name === 'stats' && !isMobile) {
        return true;
      }
      if (usersRead && item.name === 'users' && !isMobile) {
        return true;
      }
      if (rolesRead && item.name === 'roles' && !isMobile) {
        return true;
      }
      if (templates && item.name === 'templates' && !isMobile) {
        return true;
      }
      if (dashboardRead && item.name === 'dashboard' && !isMobile) {
        return true;
      }
      if (inventoryRead && data.role.inventory.permissions.includes('All') && item.name === 'inventory' && !isMobile) {
        return true;
      }
      if (inventoryRead && data.role.inventory.permissions.includes('All') && item.name === 'inventoryv0' && !isMobile) {
        return true;
      }
      if (inventoryRead && item.name === 'inventorycontrolcenter' && !isMobile) {
        return true;
      }
      if (inventoryRead && data.role.inventory.permissions.includes('Card') && item.name === 'card' && !isMobile) {
        return true;
      }
      if (inventoryRead && data.role.inventory.permissions.includes('Individual') && item.name === 'inventorypage' && !isMobile) {
        return true;
      }
      if (associateRead && data.role.associates.permissions.includes('All') && item.name === 'associatesv0' && !isMobile) {
        return true;
      } if (associateRead && item.name === 'associatescontrolcenter' && !isMobile) {
        return true;
      }
      if (associateRead && data.role.associates.permissions.includes('Managers') && item.name === 'managercontrolcenter') {
        return true;
      }
      if (associateRead && data.role.associates.permissions.includes('Triage') && item.name === 'associatestriage' && !isMobile) {
        return true;
      }
      if (associateRead && data.role.associates.permissions.includes('Individual') && item.name === 'associatepage' && !isMobile) {
        return false;
      }
      if (associateRead && data.role.associates.permissions.includes('Individual') && item.name === 'associatelayout') {
        return true;
      }
      if (associateRead && data.role.associates.permissions.includes('All') && item.name === 'associates' && !isMobile) {
        return true;
      }
      /*
    if (associateRead && data.role.associates.permissions.includes('Manager') && item.name === 'manager') {
      return true;
    }
    if (associateRead && data.role.associates.permissions.includes('Managers') && item.name === 'managers') {
      return true;
    }
    */
      if (calendarRead && item.name === 'calendar') {
        return true;
      } if (boss && item.name === 'campaign') {
        return true;
      } if (calliopeRead && boss && !isMobile && item.name === 'calliope') {
        return true;
      }
      if (calendarRead && item.name === 'billing') {
        return true;
      } if (reportsRead && item.name === 'reports') {
        return true;
      } if (alertsRead && item.name === 'alerts') {
        return true;
      } if (alertsRead && item.name === 'risks') {
        return true;
      }
    }
    return false;
  }
  return (
    <div
      className={!isMobile ? 'ml-3 h-screen md:overflow-hidden overflow-auto md:hover:overflow-auto pb-10' : ''}
    >
      {activeMenu && currentActiveMenu && (
        <>
          <div className="flex justify-between items-center" style={{ backgroundColor: '#383838' }}>
            <Link
              to="/"
              onClick={handleCloseSideBar}
              className="items-center gap-3 ml-3 mt-4 flex text-xl font-extrabold tracking-tight dark:text-white text-slate-900"
            >
              <span><img src={!isMobile ? './logo 2.png' : './mobile.jpg'} width={!isMobile ? '80' : '40'} />{boss && !isMobile ? `${REACT_APP_ENV}` : ''}
                {/*
                elapsed <= 60 && (
                <input
                  id="elapsed"
                  className="e-background-colorx"
                  name="elapsed"
                  size="6"
                  value={elapsed}
                />
                ) */}
              </span>
              {
              /*
              <span><img src="./logo.png" width="40" height="33" />Monaco<br />SENSO<b>CORE</b></span>
              */
              }
            </Link>
            <TooltipComponent content="Menu" position="BottomCenter">
              <button
                type="button"
                onClick={() => setActiveMenu(!activeMenu)}
                style={{ color: currentColor }}
                className="text-xl rounded-full p-3 hover:bg-light-gray mt-4 block md:hidden"
              >
                <MdOutlineCancel />
              </button>
            </TooltipComponent>
          </div>
          <div className="p-8" style={{ backgroundColor: '#383838' }}>
            {links.map((item) => (viewPermission(item)
              && (
              <div key={item.title}>
                <p
                  className="uppercase aubrey"
                  style={{
                    color: '#78DA89',
                  }}
                >
                  {!isMobile ? item.title : null}
                </p>
                {item.links.map((link) => (viewPermission(link)
                  && (
                  <NavLink
                    to={`/${link.name}`}
                    key={link.name}
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : '',
                      color: 'white',
                    })}
                    className={({ isActive }) => (isActive ? activeLink : normalLink)}
                  >
                    {!isMobile ? link.icon : null}
                    <span className="capitalize ">{
                    link.display && (link.display === 'inventories' || link.display === 'Inventory All' || link.name === 'inventorycontrolcenter') ? (`${link.display} (${inventoryCount})`)
                      : link.display && (link.display === 'all' || link.name === 'associatescontrolcenter') ? (`${link.display} (${associateCount})`)
                        : link.display && (link.name === 'managercontrolcenter') ? (`${link.display} (${managerCount})`)
                          : link.display ? (`${link.display}`) : (link.name)
                    }
                    </span>
                  </NavLink>
                  )
                ))}
              </div>
              )
            ))}
          </div>
        </>
      )}
    </div>
  );
};
export default Sidebar;
